import React from "react";
import { CLAIM, REGISTERED } from "../../configurations/Constants";

function PanelClaimedField({
  indexValue,
  sortedUserClaimField,
  coords,
  btnSubmitClick,
  showFieldOnMAP,
  handleClaimDeleteClick,
}) {
  const claimId = sortedUserClaimField.claim_id;
  const claimIrrigUnitId = sortedUserClaimField.claim_irrig_unit_id;
  const claimedFieldName = sortedUserClaimField.claim_field_name;
  return (
    <div className="p-relative">
      <ul key={indexValue}>
        <li>
          <a
            className="highlight-field cursor-pointer"
            onClick={(e) => {
              showFieldOnMAP(
                e,
                coords,
                1000,
                CLAIM,
                REGISTERED,
                claimIrrigUnitId
              );
            }}
          >
            {" "}
            {sortedUserClaimField.claim_field_name}{" "}
          </a>
          {btnSubmitClick ? (
            <span>
              <i className="fa-regular fa-trash-can" />
            </span>
          ) : (
            <span
              className="cursor-pointer"
              onClick={(e) => {
                handleClaimDeleteClick(
                  claimId,
                  claimIrrigUnitId,
                  claimedFieldName
                );
              }}
            >
              <i className="fa-regular fa-trash-can" />
            </span>
          )}
        </li>
      </ul>
    </div>
  );
}

export default PanelClaimedField;
